module.exports = __webpack_public_path__ + "img/icon-dots.0c004dfb.svg";